export default {
  header: 'Dobbiamo verificare il tuo numero di telefono',
  remember_device: {
    label: 'Ricorda questo dispositivo per {{days}} giorni',
  },
  buttons: {
    confirm: 'Conferma',
  },
  toasts: {
    invalid_code: 'Codice non valido. Riprova.',
  },
};
